const nrkUrls = {
    fetchResources: {
        url: '/nrk/resource/'
    },
    fetchResource: {
        url: '/nrk/resource/:id'
    },
    nrkOptions: {
        url: '/resource/actions/nrkResourceOptions'
    },
    formOptions: {
        url: '/resource/actions/formOptions'
    },
    nrkTests: {
        url: '/nrk/resource/:id/tests'
    }
};

export default nrkUrls;
